<style src="./SelectedSlot.css"></style>
<template>
    <div ref="slot">
        <transition name="fade">
            <div class="loader__spinner-container epg__loader epg__loader--program" v-if="showProgramLoader">
                <div class="loader__spinner"></div>
            </div>
        </transition>

        <transition name="fade--area">
            <div class="epg__slot-inner" v-if="!showProgramLoader">
                <h3 class="epg__slot-title">{{selectedProgram.title}}</h3>

                <div class="epg__slot-subheader">
                    <span class="epg__slot-suitability-image"><img :src = selectedProgram.suitabilityImageSrc /></span>
                    <span class="epg__slot-separator"> | </span>
                    <span class="epg__slot-duration">{{selectedProgram.duration}} '</span>
                    <span class="epg__slot-separator"> | </span>
                    <span class="epg__slot-category">{{selectedProgram.category}}</span>
                </div>

                <p :class="[
              'epg__slot-description',
              {
              'epg__slot-description--max': contentMode === 'max',
              'epg__slot-description--min': contentMode === 'min'
              }]">
                    <span></span>
                    <span v-if="contentMode === 'min'" class="epg__slot-text epg__slot-text--min">{{miniText}}</span>
                    <span v-if="contentMode === 'max'" :class="['epg__slot-text', 'epg__slot-text--max', {'epg__slot-text--show' : isMaxTextShown}]">
                        {{maxText}}
                    </span>
                </p>
                <a class="epg__link epg__link--more"  v-on:click="toggleContentMode()"  v-if="miniText.length !== maxText.length">
                    <span v-if="contentMode === 'min'">{{moreLabel}}</span>
                    <span v-if="contentMode === 'max'">{{lessLabel}}</span>
                </a>

                <div class="epg__btn epg__btn--close" v-on:click="closeSlot()">
                    <svg class="epg__icon epg__icon--close">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
                    </svg>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
  export default {
    name: 'selected-slot',
    props: ['showProgramLoader', 'selectedProgram', 'moreLabel', 'lessLabel', 'closeSlot', 'setExpandedSlotHeight', 'expandedSlotHeight', 'descriptionTruncationPoint'],
    data () {
      return {
        contentMode: 'min',
        isMaxTextShown: false
      }
    },
    computed: {
      miniText () {
        return this.truncate(this.selectedProgram.description, this.descriptionTruncationPoint, false)
      },
      maxText () {
        return this.selectedProgram.description
      }
    },
    methods: {
      toggleContentMode: function () {
        this.contentMode = this.contentMode === 'max' ? 'min' : 'max'
        const PADDING_HEIGHT = 0
        setTimeout(() => {
          this.isMaxTextShown = Boolean(this.contentMode === 'max')
          this.setExpandedSlotHeight(this.$refs.slot.getBoundingClientRect().height + PADDING_HEIGHT)
        }, 100)
      },
      truncate (str, n, useWordBoundary) {
        if (!str) { return '' }
        if (str.length <= n) { return str }
        let subString = str.substr(0, n - 1)
        return (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(' '))
          : subString) + '...'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectedSlot.vue?446c1604